import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { selectActiveServiceId } from '../../../../../../../../../../../selectors/publishTerms';
import {
  selectBaseAuctionBetByServiceId,
  selectIsAutobrokerEnabled,
} from '../../../../../../../../../../../selectors/auction';
import { formatMoney } from '../utils';
import { selectPublishTermsService as setPublishTermsService } from '../../../../../../../../../../../actions/publishTerms';
import { EServiceId } from '../../../../../../../../../../../types/reducers/publishTerms';
import { IUseServiceHook } from './types';

export const useService = (serviceId: EServiceId): IUseServiceHook => {
  const dispatch = useDispatch();
  const selectedServiceId = useSelector(selectActiveServiceId);
  const isAutobrokerEnabled = useSelector(selectIsAutobrokerEnabled);
  const priceSelector = selectBaseAuctionBetByServiceId(serviceId);
  const price = useSelector(priceSelector);

  const formattedPrice = formatMoney(price);
  const isSelected = serviceId === selectedServiceId;

  const onClick = useCallback(() => {
    if (!isSelected) {
      dispatch(setPublishTermsService(serviceId));
    }
  }, [isSelected, serviceId, dispatch]);

  return {
    onClick,
    isSelected,
    price,
    formattedPrice,
    isVisible: !(isAutobrokerEnabled && serviceId === EServiceId.paid),
  };
};
